import React, { useContext, useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { BuilderContext, useDrawer } from "react-flow-builder";
import { PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Button,
  Input,
  Select,
  Checkbox,
  Radio,
  Upload,
  Image,
  Divider,
  Space,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { store } from "../../../../../../../redux";
import { setDraft } from "../../../../../../../redux/actions/skill";
import captureXpathIcon from "../../../../../../../images/capture-xpath.png";
import imageIcon from "../../../../../../../images/image-pic.png";
import deleteRed from "../../../../../../../images/branching/close-app.svg";
import {
  getFileUrl,
  updateFileUrl,
} from "../../../../../../../redux/actions/fileUpload";

import Zoom from "react-medium-image-zoom";
import ReactTooltip from "react-tooltip";

const { Option } = Select;
let index = 0;

const ConfigForm = () => {
  let { selectedNode: node, flowVariables, nodes } = useContext(BuilderContext);
  const { closeDrawer: cancel } = useDrawer();

  const [editManual, setEditManual] = useState(false);
  const [nodeData, setNodeData] = useState(null);
  const [flowVar, setFlowVar] = useState([]);
  const [frameData, setFrameData] = useState();
  const [showReadForm, setShowReadForm] = useState(false);
  const [readValueOption, setReadValueOption] = useState(false);
  const [message, setMessage] = useState("");
  const [defaultSelector, setDefaultSelector] = useState("html");
  const [defaultConditionFlag, setDefaultConditionFlag] = useState(false);
  const [field, setField] = useState("dropdown");
  const [form] = Form.useForm();
  const skill = useSelector((state) => state.skillReducer.trainDraft);
  const _actual = nodeData?.data?.actual;
  const [isLoading, setIsLoading] = useState(false);
  const [source, setSource] = useState("");
  const inputRef = useRef(null);
  const toggleField = () => {
    setEditManual(!editManual);
  };

  const onNameChange = (event) => {
    form.setFieldsValue({
      actual: event.target.value,
    });
    setSource(event.target.value);
  };
  const addItem = (e) => {
    if (source != "") {
      e.preventDefault();
      setFlowVar([...flowVar, source]);
      setSource("");
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    }
  };
  const onDelClick = () => {
    setMessage("");
    nodeData.data.actual = "";
  };

  const props = {
    async onChange(info) {
      setIsLoading(true);
      if (info.file.status != "uploading") {
        imageUploadURL = await store.dispatch(
          getFileUrl(info.file.originFileObj)
        );
        setMessage(imageUploadURL);
        setFileList([
          {
            uid: "-1",
            name: "image.png",
            status: "done",
            url: imageUploadURL,
          },
        ]);
        setIsLoading(false);
      }
    },
  };


  const handleSubmit = async () => {
    try {
      let _act;
  
      if (field === "dropdown" && source !== "") {
        let _checkFormat = source.includes("`");
        _act = _checkFormat ? source : "`" + source + "`";
      } else if (field === "capture") {
        
        _act = form.getFieldValue("actual") || "";
      } else {
        
        let actualFromForm = form.getFieldValue("actual");
        _act = actualFromForm ? actualFromForm : "";
        if (!_act.includes("`")) {
          _act = "`" + _act + "`";
        }
      }
  
      let imageSelector = nodeData.selector === "image";
      let defaultBlock = nodeData.selector === "default";
      let values = {
        actual: imageSelector ? message : _act,
        expected: form.getFieldValue("expected") ? form.getFieldValue("expected") : "" ,
        operators: imageSelector ? "present" : form.getFieldValue("operators"),
      };
  
      let {
        skillReducer: { trainDraft },
      } = store.getState();
  
      let obj = {
        actual: values.actual,
        expected: values.expected,
        operators: values.operators,
        frame: frameData ? frameData : "",
      };
  
      nodeData["fieldValue"] = field;
      nodeData["readValue"] = readValueOption;
       // nodes = findAndUpdate(nodes, nodeData.id, { data: obj });
      nodes = findAndUpdate(nodes, nodeData.id, { data: obj, imageSelector, defaultBlock });
      nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
      
      store.dispatch(
        setDraft({
          ...trainDraft,
          RAW_DATA: { ...trainDraft.RAW_DATA, actions: nodes },
        })
      );
  
      cancel();
      setMessage(imageUploadURL);
    } catch (error) {
      console.error("Form error:", error);
      return;
    }
  };
  

  const xPathHandler = (evt) => {
    const xPath = evt.detail.xPath;
    const frame = evt.detail.frame;
    setFrameData(frame);
    let _checkXpath = xPath.split("/");
    if (
      _checkXpath.length > 0 &&
      ["input", "label", "textarea", "select"].includes(
        _checkXpath[_checkXpath.length - 1]
      )
    ) {
      setShowReadForm(true);
    } else {
      setReadValueOption(false);
      setShowReadForm(false);
    }
    form.setFieldsValue({
      actual: xPath,
      frame: frame,
    });
  };

  const captureXpath = (nodeId) => {
    window?.chrome?.runtime.sendMessage(process.env.REACT_APP_CHROME_TAB_ID, {
      type: "captureXPath",
      nodeId: nodeId,
    });
  };

  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };

  useEffect(() => {
    document.addEventListener("capturedXPath", xPathHandler);
    return () => {
      console.log("[Unmounting]");
      document.removeEventListener("capturedXPath", xPathHandler, true);
    };
  }, []);

  useEffect(() => {
    setNodeData(node);
    let _checkXpath = node?.data?.actual?.split("/");
    if (
      _checkXpath?.length > 0 &&
      ["input", "label", "textarea", "select"].includes(
        _checkXpath[_checkXpath.length - 1]
      )
    ) {
      setShowReadForm(true);
    } else {
      setShowReadForm(false);
    }
    setReadValueOption(node?.readValue ? node.readValue : false);
    setMessage(node?.data?.actual || "");
    setDefaultSelector(node?.selector ? node?.selector : "html");
    setField(node?.fieldValue ? node?.fieldValue : "dropdown");

    let mainBranchNode = skill?.RAW_DATA?.actions[0]?.children[0]?.children;
    mainBranchNode?.map((obj, ind) => {
      checkDefaultCondition(obj?.children);
    });
    
  }, [node]);

  const checkDefaultCondition = (branchNode) => {
    let isNestedBranch = true;
    branchNode?.map((obj, ind) => {
        if(obj?.id == node?.id){
          isNestedBranch = false;
        }
      });
    if(isNestedBranch){
      if(branchNode && branchNode[0]?.children?.length > 0){
        checkDefaultCondition(branchNode[0]?.children[0]?.children)
      }else if(branchNode && branchNode[1]?.children?.length > 0){
        checkDefaultCondition(branchNode[1]?.children[0]?.children)
      }
    }else{
    branchNode?.map((obj, ind) => {
      if(obj?.defaultBlock == true){
        if(obj?.id != node?.id){
        setDefaultConditionFlag(true);
      }
    }});
  }
  };

  useEffect(() => {
    if (skill?.FORMATED_DATA?.variables) {
      mergeVar(skill?.FORMATED_DATA?.variables);
    }
  }, [skill?.FORMATED_DATA?.variables]);

  const mergeVar = (allVar) => {
    let _mergedData = [];
    Object.entries(allVar).forEach(([key, value]) => {
      _mergedData.push(value);
    });
    if (flowVariables.length > 0) {
      _mergedData.map((ele) => {
        flowVariables.map((f) => {
          if (ele.id === f.id) {
            ele["xPath"] = f.xPath;
          }
          return;
        });
      });
    }
    setFlowVar(_mergedData);
  };

  let imageUploadURL;

  const [fileList, setFileList] = useState([
    {
      uid: "-1",
      name: "image.png",
      status: "done",
      url: "",
    },
  ]);

  const handleChangeSelector = (e) => {
    let {
      skillReducer: { trainDraft },
    } = store.getState();

    nodeData.selector = e.target.value;
    nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
    let newActions = findAndUpdate(nodes, nodeData.id, nodeData);
    if (nodeData.selector == "html") {
      if (nodeData?.data?.operators != "present") {
        let values = {
          actual: message,
          expected: "",
          operators: "Equal to",
        };
        nodeData.data = values;
      } else {
        let values = {
          actual: _actual,
          expected: "",
          operators: "Equal to",
        };
        nodeData.data = values;
      }
    } else if (nodeData.selector == "image") {
      if (nodeData?.data?.operators == "present") {
        let values = {
          actual: message,
          expected: "",
          operators: "present",
        };
        nodeData.data = values;
      } else {
        let values = {
          actual: _actual,
          expected: "",
          operators: "present",
        };
        nodeData.data = values;
      }
    } else{
      let values = {
        defaultBlock: true
      };
      nodeData.data = values;
    }
    store.dispatch(
      setDraft({
        ...trainDraft,
        RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
      })
    );
    setDefaultSelector(e.target.value);
  };

  const fieldRadioChange = (e) => {
    nodeData.fieldValue = e.target.value;
    setField(e.target.value);
  };

  const handleChangeNumber = (e) => {
    let {
      skillReducer: { trainDraft },
    } = store.getState();
    nodeData["numberOnly"] = e.target.checked;
    nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
    let newActions = findAndUpdate(nodes, nodeData.id, nodeData);

    store.dispatch(
      setDraft({
        ...trainDraft,
        RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
      })
    );
  };

  const handleChangeReadValue = (e) => {
    let {
      skillReducer: { trainDraft },
    } = store.getState();
    setReadValueOption(e.target.checked);
    nodeData["readValue"] = e.target.checked;
    nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
    let newActions = findAndUpdate(nodes, nodeData.id, nodeData);

    store.dispatch(
      setDraft({
        ...trainDraft,
        RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
      })
    );
  };

  const getSelector = (selector) => { 
    switch (selector) {
      case "image":
        return imageSelectorForm();
      case "html":
        return htmlSelectorForm();
      case "default":
        return defaultConditionForm();
      default:
        return htmlSelectorForm();
    }
  };

  const onChangeSelect = (e) => {
    form.setFieldsValue({
      actual: e,
    });
  };

  const htmlSelectorForm = () => {
    return (
      <Form form={form} initialValues={nodeData.data}>
        <div className="radio-selector">
          <Radio.Group
            name="radiogroup1"
            onChange={(e) => fieldRadioChange(e)}
            value={field}
          >
            <Radio value="dropdown"> Select from Dropdown </Radio>
            <Radio value="capture">Capture Field </Radio>
          </Radio.Group>
        </div>

        <div class="ant-col ant-form-item-label">
          <label for="actual" class="ant-form-item-required" title=" Source">
            {" "}
            Source
          </label>
          {field === "capture" ? (
            <Checkbox
              onChange={(e) => handleChangeNumber(e)}
              checked={nodeData?.numberOnly}
            >
              {" "}
              Extract Number Only{" "}
            </Checkbox>
          ) : null}
          {showReadForm || field === "capture" ? (
            <Checkbox
              onChange={(e) => handleChangeReadValue(e)}
              checked={readValueOption}
            >
              {" "}
              Read Value{" "}
            </Checkbox>
          ) : null}
        </div>

        {field === "dropdown" ? (
          <Form.Item
            name="actual"
            // label=" Source"
            rules={[{ required: true }]}
          >
            {/* <Select style={{ width: 120 }}>
              {flowVar.map((ele, i) => {
                return (
                  <Option
                    className="custom-select"
                    key={i}
                    value={ele.xPath
                      ? ele.xPath
                      : ele.defaultValue
                        ? ele.defaultValue
                        : "`" + ele.name + "`"}
                  >
                    <p>{ele.name}</p>
                    <Zoom>
                      <div className="img-thumb">
                        <img src={ele?.pageScreenshot} />
                      </div>
                    </Zoom>
                  </Option>
                );
              })}
            </Select> */}
            <Select
              style={{
                width: 300,
              }}
              placeholder="Source"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider
                    style={{
                      margin: "8px 0",
                    }}
                  />
                  <Space
                    style={{
                      padding: "0 8px 4px",
                    }}
                  >
                    <Input
                      placeholder="Please enter item"
                      ref={inputRef}
                      onChange={(e) => onNameChange(e)}
                      onKeyDown={(e) => e.stopPropagation()}
                      value={source}
                    />
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addItem}
                    >
                      Add item
                    </Button>
                  </Space>
                </>
              )}
              options={flowVar?.map((item) => ({
                label: item?.name ? item.name : item,
                value: item?.name ? item.name : item,
              }))}
              defaultValue={nodeData?.data?.actual}
              onChange={onChangeSelect}
            />
          </Form.Item>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "15px",
            }}
          >
            <Form.Item
              name="actual"
              // label=" Source"
              rules={[{ required: true }]}
              style={{ marginBottom: "0px" }}
              help="Eg: /html/body/div[7]/div[1]/div[1]/h2[4] OR `variableName`"
            >
              <Input />
            </Form.Item>
            <Button
              className="capture-btn"
              style={{ height: "30px", marginRight: "0px", marginTop: "0px" }}
              onClick={() => {
                captureXpath(nodeData.id);
              }}
              icon={<img src={captureXpathIcon} data-tip="Capture Field"></img>}
            ></Button>
            <ReactTooltip place="top" type="dark" effect="solid" />
          </div>
        )}

        <Form.Item
          name="operators"
          label="Condition"
          rules={[{ required: true }]}
        >
          <Select style={{ width: 120 }}>
            <Option value="equal">Equal to</Option>
            <Option value="not-equal">Not Equal to</Option>
            <Option value="greater-than">Greater than</Option>
            <Option value="less-than">Less than</Option>
            <Option value="greater-than-or-equal">
              Greater than or Equal to
            </Option>
            <Option value="less-than-or-equal">Less than or Equal to</Option>
            <Option value="contains">Contains</Option>
            <Option value="not-contains"> Does not Contains</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="expected"
          label="Target Value"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
      </Form>
    );
  };

  const defaultConditionForm = () => {
    return (
     <div>
      <h6>This condition will be set as the default branch condition and will be executed everytime</h6>
     </div>
    );
  };

  const imageSelectorForm = () => {
    return (
      <Form form={form}>
        <div className="img-selector">
          <div className="file-upload">
            <Input
              placeholder="Ex: target Url file"
              value={message ? message : _actual}
            />
            {isLoading ? (
              <Upload {...props}>
                <div class="sp sp-circle text-light"></div>
              </Upload>
            ) : (
              <Upload {...props}>
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
              </Upload>
            )}
          </div>
        </div>
        {message || _actual ? (
          <div className="img-thumb-upload">
            <span className="delete-thumb">
              <img src={deleteRed} onClick={onDelClick} />
            </span>
            <Image width={130} src={message ? message : _actual} />
          </div>
        ) : null}
      </Form>
    );
  };

  return (
    <div>
      <div className="radio-selector">
        <Radio.Group
          name="radiogroup"
          onChange={(e) => handleChangeSelector(e)}
          value={defaultSelector}
        >
          <Radio value="html">HTML Selector</Radio>
          <Radio value="image">Image Selector</Radio>
          <Radio disabled={defaultConditionFlag && defaultSelector != "default"} value="default">Default Condition</Radio>
        </Radio.Group>
        <hr />
      </div>
      {nodeData ? (
        <div>
          {getSelector(defaultSelector)}

          <div>
            <Button onClick={cancel}> Cancel </Button>
            <Button type="primary" onClick={() => handleSubmit()}>
              Save
            </Button>
          </div>
        </div>
      ) : null}
      <ul className="note-list">
        <li>Add a branched IF/ELSE condition to the skill</li>
      </ul>
    </div>
  );
};

export default ConfigForm;
